import { render, staticRenderFns } from "./professionNotice.vue?vue&type=template&id=471550c3&scoped=true&"
import script from "./professionNotice.vue?vue&type=script&lang=js&"
export * from "./professionNotice.vue?vue&type=script&lang=js&"
import style0 from "./professionNotice.vue?vue&type=style&index=0&id=471550c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471550c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('471550c3')) {
      api.createRecord('471550c3', component.options)
    } else {
      api.reload('471550c3', component.options)
    }
    module.hot.accept("./professionNotice.vue?vue&type=template&id=471550c3&scoped=true&", function () {
      api.rerender('471550c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/product/professionNotice.vue"
export default component.exports